module.exports = __webpack_public_path__ + "static/EverForward1-54d4887a37e3d7b3188596e15986b902.webp";